import React from "react";
import Input from "@amzn/meridian/input";

/**
 * Returns true if value is a whole number between min and max (both included)
 */
export const isValidInterval = (value, min, max) => {
    const trimmedValue = String(value).trim();
    if (!/^\d+$/.test(trimmedValue)) {
        return false;
    }
    const interval = Number(trimmedValue);
    return interval >= min && interval <= max;
};

/**
 * Number input for a whole-number interval (e.g. seconds between two commands) with range validation
 */
const IntervalInput = ({id, value, onChange, min = 0, max, unit, errorMessage, disabled = false, width = 120}) => {
    const isValid = isValidInterval(value, min, max);
    return (
        <Input
            id={id}
            type="number"
            value={value}
            onChange={onChange}
            error={!isValid}
            errorMessage={isValid ? undefined : errorMessage}
            suffix={unit}
            disabled={disabled}
            size="small"
            width={width}/>
    );
};

export default IntervalInput;



// WEBPACK FOOTER //
// ./src/components/commonui/IntervalInput.js